import * as types from '@phoenix/store/mutations-types';
import MixedGrid from '@maison/components/mixedGrid/MixedGrid.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  components: { MixedGrid },

  props: {
    uniqueId: {
      type: String,
      required: true,
    },
    blockFiltersId: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    ...mapActions('strapSearch', ['getStrapFromWatchReference', 'getAllStraps']),
    ...mapMutations('strapSearch', [types.STRAP_SEARCH_SET_BLOCK_FILTERS_ID, types.STRAP_SEARCH_SET_WATCH_REF]),
  },

  computed: {
    ...mapState('strapSearch', ['watchReference', 'watchCompleteReference', 'isLoading', 'filtersCta']),
    ...mapGetters('strapSearch', ['hasResult', 'hasAllStrapsResult', 'productsToDisplay']),
  },
};
